(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var MainService = (function () {
    /*@ngInject;*/

    function MainService($http, $q, LOCALHOTST_URL, $state, $timeout, $cookies) {
        _classCallCheck(this, MainService);

        this.cookies = $cookies;
        this.timeout = $timeout;
        this.state = $state;
        this.baseUrl = LOCALHOTST_URL;
        this.http = $http;
        this.q = $q;
        this.status = 'guest';
        this.token = null;
        this.userTypeSet = false;
    }

    _createClass(MainService, [{
        key: 'logInToApp',
        value: function logInToApp(login, password) {
            var _this = this;

            console.log("url" + this.baseUrl.url);
            var d = this.q.defer();
            var parameters = {
                login: login,
                password: password
            };

            this.http.get(this.baseUrl.url + '/authorization', { params: parameters }).then(function (response) {
                d.resolve(response);
                _this.status = "user";
                _this.token = response.data.token;
                _this.cookies.put('auth', _this.token);
                _this.cookies.put('x-access-token', _this.token);
            }, function (error) {
                d.reject(error.message);
            });

            return d.promise;
        }
    }, {
        key: 'authenticate',
        value: function authenticate(type) {
            var _this2 = this;

            var d = this.q.defer();

            if (!this.userTypeSet) {
                this.init();
                this.setUserType().then(function (response) {
                    console.log(response);
                    _this2.status = response.data.type;

                    console.log(type);
                    console.log(_this2.status);
                    if (type !== _this2.status) {
                        console.log(_this2.status);
                        _this2.timeout(function () {
                            switch (_this2.status) {
                                case 'guest':
                                    console.log("going loginPage");_this2.state.go('loginPage');break;
                                case 'user':
                                    _this2.state.go('userPage');break;
                            }
                        }, 0);

                        d.reject();
                    } else {
                        d.resolve();
                    }
                }, function (error) {
                    console.log("B��d kuraw ma�");
                });
            } else {
                console.log(type);
                console.log(this.status);
                if (type !== this.status) {
                    console.log(this.status);
                    this.timeout(function () {
                        switch (_this2.status) {
                            case 'guest':
                                console.log("going loginPage");_this2.state.go('loginPage');break;
                            case 'user':
                                _this2.state.go('userPage');break;
                        }
                    }, 0);
                    console.log("reject");
                    d.reject();
                } else {
                    d.resolve();
                }
            }
            return d.promise;
        }
    }, {
        key: 'setUserType',
        value: function setUserType() {
            var token = this.cookies.get('auth');
            var parameters = {
                token: token
            };
            var header = {
                'test': 'kuraw mac'
            };
            /*this.http.get(this.baseUrl.url + '/authorizedUser', {params: parameters, headers: header}).then(response => {
                console.log(response);
                this.status = response.data.type;
            }, error => {
                console.log(error.message);
            });*/

            return this.http.get(this.baseUrl.url + '/authorizedUser', { params: parameters, headers: header });
        }
    }, {
        key: 'setToken',
        value: function setToken(token) {
            this.token = token;
        }
    }, {
        key: 'init',
        value: function init() {
            console.log("init");
            this.userTypeSet = true;
        }
    }]);

    return MainService;
})();

exports['default'] = MainService;
module.exports = exports['default'];

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var ModalService = (function () {

    /*@ngInject;*/

    function ModalService($uibModal) {
        _classCallCheck(this, ModalService);

        this.uibModal = $uibModal;
        this.modalInstance = {};
        this.data = {};
    }

    _createClass(ModalService, [{
        key: 'openModal',
        value: function openModal(template, controller, size, windowClass) {
            this.modalInstance = this.uibModal.open({
                templateUrl: template,
                controller: controller,
                controllerAs: 'modal',
                windowClass: windowClass,
                size: size
            });
        }
    }, {
        key: 'setData',
        value: function setData(data) {
            this.data = angular.copy(data);
        }
    }, {
        key: 'getData',
        value: function getData() {
            return this.data;
        }
    }]);

    return ModalService;
})();

exports['default'] = ModalService;
module.exports = exports['default'];

},{}],3:[function(require,module,exports){
'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _filtersTextFilters = require('./filters/textFilters');

var _MainService = require('./MainService');

var _MainService2 = _interopRequireDefault(_MainService);

var _servicesHttpService = require('./services/HttpService');

var _servicesHttpService2 = _interopRequireDefault(_servicesHttpService);

var _configConfig = require('./config/config');

var _configConfig2 = _interopRequireDefault(_configConfig);

var _componentsLoginPageLoginPageModule = require('./components/loginPage/LoginPageModule');

var _componentsLoginPageLoginPageModule2 = _interopRequireDefault(_componentsLoginPageLoginPageModule);

var _componentsUserPageUserPageModule = require('./components/userPage/UserPageModule');

var _componentsUserPageUserPageModule2 = _interopRequireDefault(_componentsUserPageUserPageModule);

var _componentsGaleryGaleryModule = require('./components/galery/GaleryModule');

var _componentsGaleryGaleryModule2 = _interopRequireDefault(_componentsGaleryGaleryModule);

var _componentsMembersMembersModule = require('./components/members/MembersModule');

var _componentsMembersMembersModule2 = _interopRequireDefault(_componentsMembersMembersModule);

var _controlsTopBarLkfsTopBarModule = require('./controls/topBar/LkfsTopBarModule');

var _controlsTopBarLkfsTopBarModule2 = _interopRequireDefault(_controlsTopBarLkfsTopBarModule);

var _controlsLkfsSliderLkfsSliderModule = require('./controls/lkfsSlider/LkfsSliderModule');

var _controlsLkfsSliderLkfsSliderModule2 = _interopRequireDefault(_controlsLkfsSliderLkfsSliderModule);

var _controlsLkfsSideMenuLkfsSideMenuModule = require('./controls/lkfsSideMenu/LkfsSideMenuModule');

var _controlsLkfsSideMenuLkfsSideMenuModule2 = _interopRequireDefault(_controlsLkfsSideMenuLkfsSideMenuModule);

var _componentsResultsResultsModule = require('./components/results/resultsModule');

var _componentsResultsResultsModule2 = _interopRequireDefault(_componentsResultsResultsModule);

var _apiModalService = require('./api/ModalService');

var _apiModalService2 = _interopRequireDefault(_apiModalService);

angular.module('myApp', ['ui.router', 'loginPage', 'galery', 'members', 'userPage', 'ngCookies', 'ui.bootstrap', 'topBar', 'lkfsSlider', 'results', 'lkfsSideMenu', 'jkuri.gallery']).filter('upper', _filtersTextFilters.UpperFilter).filter('lower', _filtersTextFilters.LowerFilter).service('MainService', _MainService2['default']).factory('httpService', _servicesHttpService2['default']).service('ModalService', _apiModalService2['default']).directive('exampleDirective', function () {
    return new exampleDirective();
}).constant('LOCALHOTST_URL', { url: 'http://localhost:3000' }).config(_configConfig2['default']);

},{"./MainService":1,"./api/ModalService":2,"./components/galery/GaleryModule":5,"./components/loginPage/LoginPageModule":7,"./components/members/MembersModule":9,"./components/results/resultsModule":15,"./components/userPage/UserPageModule":19,"./config/config":20,"./controls/lkfsSideMenu/LkfsSideMenuModule":23,"./controls/lkfsSlider/LkfsSliderModule":26,"./controls/topBar/LkfsTopBarModule":29,"./filters/textFilters":30,"./services/HttpService":31}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var GaleryController = (function () {
    /*@ngInject*/

    function GaleryController() {
        _classCallCheck(this, GaleryController);

        this.images = [];
        this.imageIndex = 0;
        this.selectData = [];
        this.selectedItem = {};

        this.init();
    }

    _createClass(GaleryController, [{
        key: 'init',
        value: function init() {
            this.images[0] = [];
            this.images[1] = [];
            for (var i = 0; i < 20; i++) {
                this.images[0].push({
                    thumb: 'http://dummyimage.com/700x500/000/fff.jpg&text=styczen+' + i,
                    img: 'http://dummyimage.com/700x500/000/fff.jpg&text=styczen+' + i,
                    description: 'adsa'
                });
                this.images[1].push({
                    thumb: 'http://dummyimage.com/700x500/000/fff.jpg&text=luty+' + i,
                    img: 'http://dummyimage.com/700x500/000/fff.jpg&text=luty+' + i,
                    description: 'adsa'
                });
            }

            this.selectData.push({ label: "--wybierz--", id: -1 });
            this.selectData.push({ label: "Liga styczeń 2016", id: 0 });
            this.selectData.push({ label: "Liga luty 2016", id: 1 });

            this.selectedItem = this.selectData[0];
        }
    }, {
        key: 'showGalery',
        value: function showGalery() {
            return this.selectedItem.id !== -1;
        }
    }]);

    return GaleryController;
})();

exports['default'] = GaleryController;
exports['default'] = GaleryController;
module.exports = exports['default'];

},{}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _GaleryController = require('./GaleryController');

var _GaleryController2 = _interopRequireDefault(_GaleryController);

var galeryModule = angular.module('galery', []).controller('GaleryController', _GaleryController2['default']);

exports['default'] = galeryModule;
module.exports = exports['default'];

},{"./GaleryController":4}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var LoginPageController = (function () {
    /*@ngInject*/

    function LoginPageController(MainService, $state, $http) {
        _classCallCheck(this, LoginPageController);

        this.http = $http;
        this.state = $state;
        this.mainService = MainService;
    }

    _createClass(LoginPageController, [{
        key: 'log',
        value: function log() {
            var _this = this;

            this.mainService.logInToApp(this.loginLog, this.passwordLog).then(function (response) {
                if (response.data.success) {
                    _this.state.go('userPage');
                }
            });
        }
    }]);

    return LoginPageController;
})();

exports['default'] = LoginPageController;
exports['default'] = LoginPageController;
module.exports = exports['default'];

},{}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _LoginPageController = require('./LoginPageController');

var _LoginPageController2 = _interopRequireDefault(_LoginPageController);

var loginModule = angular.module('loginPage', []).controller('LoginPageController', _LoginPageController2['default']);

exports['default'] = loginModule;
module.exports = exports['default'];

},{"./LoginPageController":6}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var MembersController = (function () {
    /*@ngInject*/

    function MembersController(ModalService, MembersService) {
        _classCallCheck(this, MembersController);

        this.modalService = ModalService;
        this.memberService = MembersService;
        this.members = [];
        this.init();
    }

    _createClass(MembersController, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.memberService.getMembers().then(function (data) {
                _this.members = data;
            });
        }
    }, {
        key: 'showDetailsInModal',
        value: function showDetailsInModal(data) {
            this.modalService.setData(data);
            this.modalService.openModal('/components/members/modals/memberModalTemplate.html', 'MemberModalController', 'sm', 'lkfs-members-modal');
        }
    }]);

    return MembersController;
})();

exports['default'] = MembersController;
module.exports = exports['default'];

},{}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _MembersController = require('./MembersController');

var _MembersController2 = _interopRequireDefault(_MembersController);

var _modalsMemberModalController = require('./modals/MemberModalController');

var _modalsMemberModalController2 = _interopRequireDefault(_modalsMemberModalController);

var _MembersService = require('./MembersService');

var _MembersService2 = _interopRequireDefault(_MembersService);

var membersModule = angular.module('members', []).controller('MembersController', _MembersController2['default']).controller('MemberModalController', _modalsMemberModalController2['default']).service('MembersService', _MembersService2['default']);

exports['default'] = membersModule;
module.exports = exports['default'];

},{"./MembersController":8,"./MembersService":10,"./modals/MemberModalController":11}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MembersService = (function () {
    /*@ngInject*/

    function MembersService($q, $http) {
        _classCallCheck(this, MembersService);

        this.q = $q;
        this.http = $http;
    }

    _createClass(MembersService, [{
        key: "getMembers",
        value: function getMembers() {
            var d = this.q.defer();

            this.http.get('http://localhost:3000/members').then(function (response) {
                d.resolve(response.data);
            }, function (error) {
                console.log("Error, cannot get members data !");
            });

            return d.promise;
        }
    }]);

    return MembersService;
})();

exports["default"] = MembersService;
module.exports = exports["default"];

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MemberModalController = (function () {
    /*@ngInject*/

    function MemberModalController(ModalService) {
        _classCallCheck(this, MemberModalController);

        this.modalService = ModalService;
        this.data = this.modalService.getData();
    }

    _createClass(MemberModalController, [{
        key: "close",
        value: function close() {
            this.modalService.modalInstance.close();
        }
    }]);

    return MemberModalController;
})();

exports["default"] = MemberModalController;
module.exports = exports["default"];

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResultsController =
/*@ngInject*/
function ResultsController() {
    _classCallCheck(this, ResultsController);

    this.tabs = [{ name: "Terminarz", view: "results.schedule" }, { name: "Wyniki", view: "results.resultsTable" }];
};

exports["default"] = ResultsController;
exports["default"] = ResultsController;
module.exports = exports["default"];

},{}],13:[function(require,module,exports){
/*@ngInject*/
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
function ResultsRoutes($stateProvider, $urlRouterProvider) {

    $urlRouterProvider.when('/results', '/results/schedule');

    $stateProvider.state('results.schedule', {
        url: '/schedule',
        templateUrl: './components/results/schedule/scheduleTemplate.html',
        controller: 'ScheduleController',
        controllerAs: 'schedule'
    }).state('results.resultsTable', {
        url: '/resultsTable',
        templateUrl: "./components/results/resultsTable/resultsTableTemplate.html",
        controller: 'ResultsTableController',
        controllerAs: 'resultsTable'
    });
}

ResultsRoutes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];

exports['default'] = ResultsRoutes;
module.exports = exports['default'];

},{}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResultsService = (function () {
    /*@ngInject*/

    function ResultsService($http, $q) {
        _classCallCheck(this, ResultsService);

        this.http = $http;
        this.q = $q;
    }

    _createClass(ResultsService, [{
        key: "getScheduleData",
        value: function getScheduleData() {
            var d = this.q.defer();

            this.http.get('/mockData/mockSchedule.json').then(function (response) {
                d.resolve(response.data);
            }, function (error) {
                console.log("Nie mo�na pobra� terminarzu");
            });

            return d.promise;
        }
    }]);

    return ResultsService;
})();

exports["default"] = ResultsService;
exports["default"] = ResultsService;
module.exports = exports["default"];

},{}],15:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _ResultsController = require('./ResultsController');

var _ResultsController2 = _interopRequireDefault(_ResultsController);

var _resultsTableResultsTableController = require('./resultsTable/ResultsTableController');

var _resultsTableResultsTableController2 = _interopRequireDefault(_resultsTableResultsTableController);

var _scheduleScheduleController = require('./schedule/ScheduleController');

var _scheduleScheduleController2 = _interopRequireDefault(_scheduleScheduleController);

var _ResultsService = require('./ResultsService');

var _ResultsService2 = _interopRequireDefault(_ResultsService);

var _ResultsRoutes = require('./ResultsRoutes');

var _ResultsRoutes2 = _interopRequireDefault(_ResultsRoutes);

var resultsModule = angular.module('results', []).controller('ResultsController', _ResultsController2['default']).controller('ResultsTableController', _resultsTableResultsTableController2['default']).controller('ScheduleController', _scheduleScheduleController2['default']).service('ResultsService', _ResultsService2['default']).config(_ResultsRoutes2['default']);

exports['default'] = resultsModule;
module.exports = exports['default'];

},{"./ResultsController":12,"./ResultsRoutes":13,"./ResultsService":14,"./resultsTable/ResultsTableController":16,"./schedule/ScheduleController":17}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResultsTableController =
/*@ngInject*/
function ResultsTableController(ResultsService) {
    _classCallCheck(this, ResultsTableController);
};

exports["default"] = ResultsTableController;
exports["default"] = ResultsTableController;
module.exports = exports["default"];

},{}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScheduleController = (function () {
    /*@ngInject*/

    function ScheduleController(ResultsService) {
        _classCallCheck(this, ScheduleController);

        this.resultsService = ResultsService;
        this.data = [];

        this.getSchedule();
    }

    _createClass(ScheduleController, [{
        key: "getSchedule",
        value: function getSchedule() {
            var _this = this;

            this.resultsService.getScheduleData().then(function (data) {
                _this.data = data;
                console.log(data);
            });
        }
    }]);

    return ScheduleController;
})();

exports["default"] = ScheduleController;
exports["default"] = ScheduleController;
module.exports = exports["default"];

},{}],18:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var UserPageController = (function () {
    /*@ngInject*/

    function UserPageController(MainService, $cookies, $state) {
        _classCallCheck(this, UserPageController);

        this.state = $state;
        this.cookies = $cookies;
        this.mainService = MainService;
        this.tittle = "user page";
    }

    _createClass(UserPageController, [{
        key: 'logout',
        value: function logout() {
            this.cookies.remove('auth');
            this.state.go('loginPage');
            this.mainService.status = 'guest';
        }
    }]);

    return UserPageController;
})();

exports['default'] = UserPageController;
exports['default'] = UserPageController;
module.exports = exports['default'];

},{}],19:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _UserPageController = require('./UserPageController');

var _UserPageController2 = _interopRequireDefault(_UserPageController);

var userModule = angular.module('userPage', []).controller('UserPageController', _UserPageController2['default']);

exports['default'] = userModule;
module.exports = exports['default'];

},{"./UserPageController":18}],20:[function(require,module,exports){
/*@ngInject*/
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
function Routes($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider) {
    $urlRouterProvider.when('/', '/members');
    //$urlRouterProvider.ot('/', '/members');

    $httpProvider.interceptors.push('httpService');
    $urlRouterProvider.otherwise('/members');

    $stateProvider.state('loginPage', {
        url: '/',
        templateUrl: './components/loginPage/loginPageTemplate.html',
        controller: 'LoginPageController',
        controllerAs: 'logPage'
    }). /*resolve: {
            secure: /!*@ngInject*!/function(MainService) {
                return MainService.authenticate('guest');
            }
        }*/
    state('userPage', {
        url: '/app',
        templateUrl: "./components/userPage/userPageTemplate.html",
        controller: 'UserPageController',
        controllerAs: 'userPage'
    }). /*resolve: {
            secure: /!*@ngInject*!/function(MainService) {
                return MainService.authenticate('user');
            }
        }*/
    state('galery', {
        url: '/galery',
        templateUrl: "./components/galery/galeryTemplate.html",
        controller: 'GaleryController',
        controllerAs: 'galery'
        /*resolve: {
         secure: /!*@ngInject*!/function(MainService) {
         return MainService.authenticate('user');
         }
         }*/
    }).state('members', {
        url: '/members',
        templateUrl: "./components/members/membersTemplate.html",
        controller: 'MembersController',
        controllerAs: 'members'
        /*resolve: {
         secure: /!*@ngInject*!/function(MainService) {
         return MainService.authenticate('user');
         }
         }*/
    }).state('results', {
        url: '/results',
        templateUrl: "./components/results/resultsTemplate.html",
        controller: 'ResultsController',
        controllerAs: 'results'
        /*resolve: {
         secure: /!*@ngInject*!/function(MainService) {
         return MainService.authenticate('user');
         }
         }*/
    });

    $; /*locationProvider.html5Mode({
          enabled: true,
          requireBase: false
       });*/
}

Routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider', '$httpProvider'];

exports['default'] = Routes;
module.exports = exports['default'];

},{}],21:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var LkfsSideMenuController =
/*@ngInject*/
function LkfsSideMenuController() {
    _classCallCheck(this, LkfsSideMenuController);

    this.items = [{ name: 'O nas', state: 'galery', icon: 'glyphicon glyphicon-info-sign' }, { name: 'Galeria', state: 'galery', icon: 'glyphicon glyphicon-picture' }, { name: 'Klubowicze', state: 'members', icon: 'fa fa-users' }, { name: 'Wyniki / terminarz', state: 'results', icon: 'glyphicon glyphicon-calendar' }, { name: 'Kontakt', state: 'members', icon: 'glyphicon glyphicon-envelope' }];
};

exports['default'] = LkfsSideMenuController;
exports['default'] = LkfsSideMenuController;
module.exports = exports['default'];

},{}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LkfsSideMenuDirective = (function () {
    /*@ngInject*/

    function LkfsSideMenuDirective() {
        _classCallCheck(this, LkfsSideMenuDirective);

        this.restrict = "E";
        this.templateUrl = "./controls/lkfsSideMenu/lkfsSideMenuTemplate.html";
        this.controller = 'LkfsSideMenuController';
        this.controllerAs = 'menu';
        this.replace = true;
    }

    _createClass(LkfsSideMenuDirective, [{
        key: "link",
        value: function link(scope, element, attrs) {}
    }]);

    return LkfsSideMenuDirective;
})();

exports["default"] = LkfsSideMenuDirective;
module.exports = exports["default"];

},{}],23:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _LkfsSideMenuController = require('./LkfsSideMenuController');

var _LkfsSideMenuController2 = _interopRequireDefault(_LkfsSideMenuController);

var _LkfsSideMenuDirective = require('./LkfsSideMenuDirective');

var _LkfsSideMenuDirective2 = _interopRequireDefault(_LkfsSideMenuDirective);

var lkfsSideMenu = angular.module('lkfsSideMenu', []).controller('LkfsSideMenuController', _LkfsSideMenuController2['default']).directive('lkfsSideMenu', function () {
    return new _LkfsSideMenuDirective2['default']();
});

exports['default'] = lkfsSideMenu;
module.exports = exports['default'];

},{"./LkfsSideMenuController":21,"./LkfsSideMenuDirective":22}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LkfsSliderController = (function () {
    /*@ngInject*/

    function LkfsSliderController($timeout) {
        _classCallCheck(this, LkfsSliderController);

        this.timeout = $timeout;
        this.slides = [];
        this.test = "siemanko";
        this.active = -1;
        this.init();
    }

    _createClass(LkfsSliderController, [{
        key: "init",
        value: function init() {
            for (var i = 1; i < 5; i++) {
                this.slides.push({
                    image: 'http://dummyimage.com/600x150/000/fff.jpg&text=image+' + i,
                    id: i
                });
            }

            this.initSlide = {
                image: "http://dummyimage.com/600x150/000/fff.jpg&text=image+0",
                id: 0
            };
        }
    }, {
        key: "next",
        value: function next() {
            console.log(this.active);
            var temp = "img[id=" + this.active + "]";
            angular.element(document).find(temp).css('display', 'none');
            if (this.active < this.slides.length - 1) {
                this.active++;
            } else {
                this.active = 0;
            }
            temp = "img[id=" + this.active + "]";
            angular.element(document).find(temp).css('display', 'block');
            angular.element(document).find(temp).animate({
                opacity: 0.25,
                left: "+=50",
                height: "toggle"
            });
        }
    }, {
        key: "previous",
        value: function previous() {
            if (this.active > 0) {
                this.active--;
            } else {
                this.active = this.slides.length - 1;
            }
        }
    }]);

    return LkfsSliderController;
})();

exports["default"] = LkfsSliderController;
exports["default"] = LkfsSliderController;
module.exports = exports["default"];

},{}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LkfsSliderDirective = (function () {
    /*@ngInject*/

    function LkfsSliderDirective($timeout) {
        _classCallCheck(this, LkfsSliderDirective);

        this.timeout = $timeout;
        this.restrict = "E";
        this.templateUrl = "./controls/lkfsSlider/lkfsSliderTemplate.html";
        this.controller = 'LkfsSliderController';
        this.controllerAs = 'slider';
        this.replace = true;
    }

    _createClass(LkfsSliderDirective, [{
        key: "link",
        value: function link(scope, element, attrs) {
            element.find('.carousel').carousel();
        }
    }]);

    return LkfsSliderDirective;
})();

exports["default"] = LkfsSliderDirective;
module.exports = exports["default"];

},{}],26:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _LkfsSliderController = require('./LkfsSliderController');

var _LkfsSliderController2 = _interopRequireDefault(_LkfsSliderController);

var _LkfsSliderDirective = require('./LkfsSliderDirective');

var _LkfsSliderDirective2 = _interopRequireDefault(_LkfsSliderDirective);

var lkfsSliderModule = angular.module('lkfsSlider', []).controller('LkfsSliderController', _LkfsSliderController2['default']).directive('lkfsSlider', function () {
    return new _LkfsSliderDirective2['default']();
});

exports['default'] = lkfsSliderModule;
module.exports = exports['default'];

},{"./LkfsSliderController":24,"./LkfsSliderDirective":25}],27:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var LkfsTopBarController = (function () {
    /*@ngInject*/

    function LkfsTopBarController() {
        _classCallCheck(this, LkfsTopBarController);

        this.slides = [];
        this.interval = 3000;
        this.active = 0;
        this.initSlides();
    }

    _createClass(LkfsTopBarController, [{
        key: 'initSlides',
        value: function initSlides() {
            console.log('dupa blada');
            for (var i = 1; i < 5; i++) {
                this.slides.push({
                    image: 'http://dummyimage.com/600x150/000/fff.jpg&text=image+' + i,
                    id: i
                });
            }
        }
    }]);

    return LkfsTopBarController;
})();

exports['default'] = LkfsTopBarController;
exports['default'] = LkfsTopBarController;
module.exports = exports['default'];

},{}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LkfsTopBarDirective = (function () {
    function LkfsTopBarDirective() {
        _classCallCheck(this, LkfsTopBarDirective);

        this.restrict = "E";
        this.templateUrl = "./controls/topBar/lkfsTopBarTemplate.html";
        this.controller = 'LkfsTopBarController';
        this.controllerAs = 'topBar';
        this.replace = true;
    }

    _createClass(LkfsTopBarDirective, [{
        key: "link",
        value: function link(scope, element, attrs) {}
    }]);

    return LkfsTopBarDirective;
})();

exports["default"] = LkfsTopBarDirective;
module.exports = exports["default"];

},{}],29:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _LkfsTopBarController = require('./LkfsTopBarController');

var _LkfsTopBarController2 = _interopRequireDefault(_LkfsTopBarController);

var _LkfsTopBarDirective = require('./LkfsTopBarDirective');

var _LkfsTopBarDirective2 = _interopRequireDefault(_LkfsTopBarDirective);

var topBarModule = angular.module('topBar', []).controller('LkfsTopBarController', _LkfsTopBarController2['default']).directive('topBar', function () {
    return new _LkfsTopBarDirective2['default']();
});

exports['default'] = topBarModule;
module.exports = exports['default'];

},{"./LkfsTopBarController":27,"./LkfsTopBarDirective":28}],30:[function(require,module,exports){
/* You could also export multiple functions (or classes) from one file. */

"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.UpperFilter = UpperFilter;
exports.LowerFilter = LowerFilter;

function UpperFilter() {
	return function (input) {
		return input.toUpperCase();
	};
}

function LowerFilter() {
	return function (input) {
		return input.toLowerCase();
	};
}

},{}],31:[function(require,module,exports){
/*
class HttpService {

    /!*@ngInject;*!/
    constructor($cookies) {
        this.cookies = $cookies;
    }

    request(config) {

        config.headers = {
            'dupa': this.cookies.get('auth')
        };

        return config;
    }
}
*/

'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = HttpService;

/*@ngInject;*/
function HttpService($cookies) {

    return {
        request: function request(config) {
            config.headers = {
                'dupa': $cookies.get('auth')
            };

            return config;
        }
    };
}

exports['default'] = HttpService;
module.exports = exports['default'];

},{}]},{},[3])

